import { render } from "./embedded-form.vue?vue&type=template&id=58a4fdf9"
import script from "./embedded-form.vue?vue&type=script&lang=js"
export * from "./embedded-form.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__